import React from 'react';
import GeckoIcon from '../../icon/icon';
import { TooltipIdStr, Tooltip, OverlayTrigger } from '../../../';

const Text = ({
  value,
  onChange,
  name,
  hasTooltip = false,
  error,
  wrapperClassName = '',
  inputClassName = '',
  ...props
}) => {
  const tipId = TooltipIdStr(name);
  return hasTooltip ? (
    <div className={`field-input-container ${wrapperClassName}`}>
      <input
        className={inputClassName}
        id={name}
        value={value}
        name={name}
        onChange={onChange}
        {...props}
      />
      {error ? (
        <React.Fragment>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`${tipId}-tooltip`}>{error}</Tooltip>
            }
          >
            <span
              role="alert"
              aria-describedby={`${tipId}-tooltip`}
              className="field-icon"
              id={tipId}
            >
              <GeckoIcon icon="far fa-info-circle" />
            </span>
          </OverlayTrigger>
        </React.Fragment>
      ) : null}
    </div>
  ) : (
    <input id={name} value={value} name={name} onChange={onChange} {...props} />
  );
};

export default Text;
